import { url } from 'utils/urls';
import axios from "axios";

const withCredentials = true;

export const asyncGetEmbedAnalytics = (embedUUID, filters) => axios.post(`${url.ppa.embeds}/${embedUUID}/metrics`, filters, { withCredentials })